import {
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { DAYS_OF_THE_WEEK } from "contexts/NewCampaign";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext } from "react";
import { Campaign } from "schemas/dashboard";

import { convertTo12HourFormat, formatCampaignDate } from "utils/time";

interface Props {
  campaign: Campaign | null;
  partialCampaign?: Campaign;
}

const UneditableCampaignDetails = ({ partialCampaign, campaign }: Props) => {
  const { templates: allTemplates } = useContext(OutreachTemplatesContext);

  const templates = campaign?.emailSetting?.emailSettingTemplates?.map(
    (emailSettingTemplate) =>
      allTemplates.find((t) => t.id === emailSettingTemplate.templateId),
  );
  const selectedFollowups = templates?.slice(1, templates?.length);

  return (
    <Grid container rowGap={2}>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontSize: 15, color: grey[700] }}>
          Campaign Details
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Outreach Template</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        <Typography color="textSecondary">
          {templates && templates[0]?.name}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Campaign Dates</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        <Typography color="textSecondary">
          {formatCampaignDate(partialCampaign?.startDate)} to{" "}
          {formatCampaignDate(partialCampaign?.endDate)}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Sending Time</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        <Typography color="textSecondary">
          {convertTo12HourFormat(partialCampaign?.startTime)} to{" "}
          {convertTo12HourFormat(partialCampaign?.endTime)} (
          {partialCampaign?.timezone})
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Days of the Week</Typography>
      </Grid>
      <Grid item xs={6} sm={8} sx={{ mb: 2 }}>
        <ToggleButtonGroup value={partialCampaign?.daysOfWeek} size="small">
          {DAYS_OF_THE_WEEK.map((day) => (
            <ToggleButton key={day[0]} value={day[0]} disabled>
              {day[1]}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Follow-up Templates</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        <Typography component="div" color="textSecondary">
          {selectedFollowups?.map((followup, index) => (
            <Grid container sx={{ mb: 1 }} key={index}>
              <Grid container alignItems="center">
                {followup?.name}
              </Grid>
              <Grid container>
                <Typography
                  variant="caption"
                  sx={{ fontStyle: "italic", fontSize: 10 }}
                  color="textSecondary"
                >
                  Sent 4 business days after previous email
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default UneditableCampaignDetails;
